import { useId, useState } from 'react';
import type { FunctionComponent } from 'react';
import { CaretDown, CaretRight, CaretUp } from '@phosphor-icons/react';
import { Transition } from '@headlessui/react';
import wcc_logo from '@assets/wcc_logo.svg';

const listItemStyles = `text-action-link hover:text-action-link-hover md:text-action-button md:hover:bg-action-button-hover flex w-full cursor-pointer items-center justify-between border-none bg-transparent py-5
font-bold md:m-0 md:whitespace-nowrap md:rounded md:py-1 md:px-2.5 text-body md:underline tracking-normal
md:hover:text-white md:hover:no-underline focus:underline md:focus:bg-action-focus md:focus:text-action-button focus:outline-none
`;

const ListItem: React.FC<{ href: string; label: string }> = ({
  href,
  label,
}) => (
  <li className="border-b-brand-primary border-b border-solid border-opacity-25 last:border-b-transparent md:border-b-transparent">
    <a href={href} className={listItemStyles} target="_blank" rel="noreferrer">
      {label}
      <CaretRight className="md:hidden" />
    </a>
  </li>
);

export const menuItems = [
  {
    href: 'https://www.westminster.gov.uk/residents',
    label: 'Residents',
  },
  {
    href: 'https://www.westminster.gov.uk/businesses',
    label: 'Businesses',
  },
  {
    href: `${import.meta.env.VITE_MYWESTMINSTER_DASHBOARD}`,
    label: 'MyWestminster accounts',
  },
];

const List = () => (
  <ul className="md:flex md:gap-x-[10px]">
    {menuItems.map((item) => (
      <ListItem key={item.href} {...item} />
    ))}
  </ul>
);

export const WCCHeader: FunctionComponent = () => {
  const [open, setOpen] = useState(false);
  const id = useId();

  const toggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  return (
    <header className="section-horizontal-padding bg-background-paper w-full">
      <nav
        aria-label="Primary"
        className="flex min-h-[5rem] flex-col items-stretch pt-4 md:justify-center md:py-4"
      >
        <div className="flex w-full items-center justify-between">
          <a
            href="https://www.westminster.gov.uk"
            className="outline-link-focus-bg focus:bg-link-focus-bg"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src={wcc_logo}
              className={`h-[2rem] w-[8.25rem]`}
              alt="Westminster Gov HomePage"
            />
          </a>
          <button
            className="secondary-button border-action-button text-action-button focus:bg-action-focus
             hover:bg-action-button text-bodyLg flex items-center gap-1 rounded
             border-2 px-3 py-2 font-normal hover:text-white focus:border-2 focus:border-solid focus:border-transparent
             focus:text-black focus:outline-none active:text-white md:hidden"
            onClick={toggle}
            aria-controls={id}
            aria-expanded={open}
          >
            Menu
            {open ? <CaretUp /> : <CaretDown />}
          </button>

          <div className="hidden md:flex md:justify-end	">
            <div id={id}>
              <List />
            </div>
          </div>
        </div>
        <div className="md:hidden">
          <Transition
            show={open}
            as="div"
            className="grid overflow-hidden"
            enter="transition-[grid-template-rows] motion-reduce:transition-none duration-150"
            enterFrom="grid-rows-[0fr]"
            enterTo="grid-rows-[1fr]"
            leave="transition-all motion-reduce:transition-none duration-150"
            leaveFrom="grid-rows-[1fr]"
            leaveTo="grid-rows-[0fr]"
          >
            <div id={id} className="min-h-0">
              <List />
            </div>
          </Transition>
        </div>
      </nav>
    </header>
  );
};
